"use strict"

import React, { useState, useEffect } from "react"

import ReactSelectionElement from "../../../shared_components/widgets/ReactSelectionElement"
import { getObjectsList } from "../../../Loaders"
import { logToServer } from "../../../ErrorBoundary"

export default function FileUploadSearchFilter({ filterEditorOnSearch, intl }) {
  const [queryString, setQueryString] = useState("")
  const filterTable = (e) => {
    e.preventDefault()
    filterEditorOnSearch(queryString, "search")
  }

  const [filetypes, setFileTypes] = useState([])
  useEffect(() => {
    getObjectsList("/lake/filetypes/")
      .then((data) => {
        setFileTypes(data.map((f) => f.name))
      })
      .catch((err) => {
        console.error(err)
        logToServer(err)
      })
  }, [])

  return (
    <form style={{ marginTop: "15px" }} onSubmit={filterTable}>
      <div className={"row one-rem-margin-bottom"}>
        <div className={"col-sm-5"}>
          <input
            className={"form-control"}
            type={"text"}
            placeholder={intl.formatMessage({ id: "general.search" })}
            value={queryString}
            onChange={(e) => setQueryString(e.target.value)}
          />
        </div>
        <div className={"col-sm-2"}>
          <ReactSelectionElement
            name={"transformation_state"}
            list={["New", "Started", "OK", "Warning", "Error"] // These options should be TransformationState ChoiceEnum options
              .map((s) => {
                return { value: s }
              })}
            placeholder={intl.formatMessage({ id: "general.status", defaultMessage: "Status" })}
            onValueChange={(name, selected) => filterEditorOnSearch(selected?.value || null, name)}
            isMulti={false}
          />
        </div>
        {filetypes.length > 0 && (
          <div className={"col-sm-2"}>
            <ReactSelectionElement
              name={"filetype"}
              list={filetypes.map((s) => {
                return { value: s }
              })}
              placeholder={intl.formatMessage({ id: "general.type", defaultMessage: "Type" })}
              onValueChange={(name, selected) => filterEditorOnSearch(selected?.value || null, name)}
              isMulti={false}
            />
          </div>
        )}
        <div className={"col-sm-1"}>
          <button type="submit" className="btn btn-primary">
            {intl.formatMessage({ id: "general.search" })}
          </button>
        </div>
      </div>
    </form>
  )
}
